import React from "react";
import { Link } from "react-router-dom";
import { company, mapsUrl, whatsappUrl } from "../data/companyData";
import { productCategories } from "../data/productsData";
import "../styles/Footer.css";

const SOCIALS = [
  { icon: "fa-brands fa-whatsapp", label: "WhatsApp", href: whatsappUrl },
  { icon: "fas fa-envelope", label: "Email", href: `mailto:${company.email}` },
  { icon: "fas fa-phone", label: "Call", href: `tel:${company.phones.office.tel}` },
  { icon: "fas fa-location-dot", label: "Map", href: mapsUrl },
];

const Footer = () => (
  <footer className="foot">
    <div className="shell">
      <div className="foot__cols">
        <div>
          <p className="foot__title">{company.name}</p>
          <p className="foot__blurb">
            Importer and wholesale distributor of industrial chemicals, mineral
            salts and agricultural humates. Operating out of Mumbai since{" "}
            {company.established}, sourcing at origin and delivering across
            India.
          </p>
          <div className="foot__socials">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                className="foot__social"
                aria-label={s.label}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel={s.href.startsWith("http") ? "noreferrer" : undefined}>
                <i className={s.icon} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>

        <nav aria-label="Site">
          <p className="foot__title">Navigate</p>
          <ul className="foot__list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/about">About us</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        <nav aria-label="Catalogue">
          <p className="foot__title">Catalogue</p>
          <ul className="foot__list">
            {productCategories.map((cat) => (
              <li key={cat}>
                <Link to={`/search?q=${encodeURIComponent(cat)}`}>{cat}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="foot__title">Get in touch</p>
          <address className="foot__addr">
            <div>
              <strong>Office</strong>
              <a href={mapsUrl} target="_blank" rel="noreferrer">
                {company.address.lines.join(", ")}
              </a>
            </div>
            <div>
              <strong>Phone</strong>
              <a href={`tel:${company.phones.office.tel}`}>
                {company.phones.office.display}
              </a>
            </div>
            <div>
              <strong>Email</strong>
              <a href={`mailto:${company.email}`}>{company.email}</a>
            </div>
          </address>
        </div>
      </div>

      <div className="foot__wordmark" aria-hidden="true">
        <h2>
          <span>Devanshi</span>
          <span>Corporation</span>
        </h2>
      </div>

      <div className="foot__legal">
        <span>© {new Date().getFullYear()} {company.name}</span>
        <span className="dot">∙</span>
        <span>GST {company.gst}</span>
        <span className="dot">∙</span>
        <span>{company.business}</span>
        <button
          type="button"
          className="foot__top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
          Back to top <span aria-hidden="true">↑</span>
        </button>
      </div>
    </div>
  </footer>
);

export default Footer;
